import { request } from '@/api/index';
import { api } from "@/api/env";
export function editorFileUpload(data) {
  return request({
    url: '/api/Resource/Image',
    method: 'post',
    data: data
  });
}
export function fileUpload(data) {
  return request({
    url: '/api/Resource/Upload',
    method: 'post',
    data: data
  });
}
export function getEditorFileSrc(params) {
  return request({
    url: '/api/Resource/Download',
    method: 'get',
    params: params,
    responseType: 'blob',
    getHeaders: true
  });
}
var fileDownloadUrl = "".concat(api, "/api/Resource/Download");
export { fileDownloadUrl };